import { Flame, Heart, ThumbsDown, ThumbsUp, Laugh, Eye } from 'lucide-react';

export const COMMENT_REACTIONS = [
  { emoji: '🔥', value: 'fire', icon: Flame, color: 'text-orange-500' },
  { emoji: '👍', value: 'thumbs_up', icon: ThumbsUp, color: 'text-blue-500' },
  {
    emoji: '👎',
    value: 'thumbs_down',
    icon: ThumbsDown,
    color: 'text-gray-500',
  },
  { emoji: '👏', value: 'clap', icon: null, color: 'text-yellow-500' },
  { emoji: '❤️', value: 'heart', icon: Heart, color: 'text-red-500' },
  { emoji: '😂', value: 'laugh', icon: Laugh, color: 'text-yellow-500' },
  { emoji: '🤔', value: 'think', icon: null, color: 'text-purple-500' },
  { emoji: '👀', value: 'eyes', icon: Eye, color: 'text-green-500' },
] as const;

export type CommentReactionValue = (typeof COMMENT_REACTIONS)[number]['value'];
